import React, { useEffect, useMemo, useState } from 'react'
import { Container, Row, Col } from '@paypalcorp/pp-react'
import { PreviousPageLink } from '../../components/video-lib/components/PreviousPageLink'
import { VideoSection } from '../../components/video-lib/sections/VideoSection'
import { VideoSidePanel } from '../../components/video-lib/sections/VideoSidePanel'
import { navigate } from 'gatsby'
import '../../components/video-lib/css/index.css'
import VideoLayout from '../../components/video-lib/components/VideoLayout'
import {
  isBrowser,
  RelatedResource,
} from '../../components/video-lib/utils/common'
import videos from '../../components/video-lib/data/videos.json'
import useParams from '../../hooks/useParams'
import { groupBy } from 'lodash'

/*
 Route has to be with videoId as query params
*/

function Watch() {
  const { videoId } = useParams()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [videoId])

  const { video, relatedVideos } = useMemo(() => {
    const expandVideoProductIds = (item) => {
      const ids = Array.isArray(item['video-Product-id'])
        ? item['video-Product-id']
        : [item['video-Product-id'] || 'others']
      return ids.map((id) => ({
        ...item,
        'video-Product-id': id.toLowerCase().replace(/\s+/g, ''),
      }))
    }
    const expandedVideos = videos.flatMap(expandVideoProductIds)
    const video = expandedVideos?.find((v) => v?.id === videoId)
    return {
      video,
      relatedVideos: expandedVideos.filter(
        (v) =>
          v?.['video-Product-id'] === video?.['video-Product-id'] &&
          v?.id !== videoId,
      ),
    }
  }, [videoId])
  const isValid = useMemo(
    () => videos.some(({ id: playlistVideo }) => playlistVideo === videoId),
    [videoId],
  )

  if (!isValid) {
    isBrowser() && navigate('/video/collection?filter=all')
  }

  const { supplementalInfo } = video || {}

  return (
    <>
      <Container style={{ marginBottom: '2rem' }}>
        <Row
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '2rem 0',
          }}
        >
          <PreviousPageLink url="/video/home" label="Back to Videos" />
          <h1 style={{ margin: '0' }} data-tesid="header-title">
            {video?.title}
          </h1>
        </Row>
        <Row>
          <Col md={7}>
            <VideoSection video={video} />
          </Col>
          <Col md={4}>
            {videoId && (
              <VideoSidePanel
                relatedVideos={relatedVideos}
                relatedResources={
                  supplementalInfo?.relatedResources as RelatedResource[]
                }
              />
            )}
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default function VideoWrapper() {
  return (
    <VideoLayout>
      <Watch />
    </VideoLayout>
  )
}
